import React, { useState } from 'react';
import { Button, Input } from 'edozvola-frontend-lib/dist/ui/components';
import ProjectDocumentsTable from 'app/edozvola/cases/project-documents/project-documents-table';
import ProjectDocumentsForm from 'app/edozvola/cases/project-documents/project-documents-form';
import AttachmentModal, { AttachmentModalVariant } from 'app/edozvola/cases/project-documents/attachment-modal/attachment-modal';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { projectDocumentsCaseUuidToCopyFromSchema } from 'app/edozvola/cases/project-documents/model/project-documents.schema';
import { copyProjectDocumentsFromCaseQuery } from 'app/edozvola/cases/project-documents/service/project-document.queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CASE_TAB_ENUM } from 'app/config/constants';
import ProjectDocumentsFormWithNonMandatoryOib from 'app/edozvola/cases/project-documents/project-documents-form-with-non-mandatory-oib';
import { getCaseContext } from 'app/shared/util/context-util';

const ProjectDocuments = ({ loaderData = null }) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idProjectDocument, setIdProjectDocument] = useState<string | null>(null);
  const [idProjectDocumentForAttachments, setIdProjectDocumentForAttachments] = useState<string | null>(null);
  const [projectAttachmentVariant, setProjectAttachmentVariant] = useState<AttachmentModalVariant>();
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const projectDocumentsVariant = loaderData;

  const copyProjectDocumentsFormik = useFormik({
    initialValues: { caseUuidToCopyFrom: '' },
    validationSchema: projectDocumentsCaseUuidToCopyFromSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => copyProjectDocuments(values.caseUuidToCopyFrom),
  });

  const { mutate: copyProjectDocuments, isPending: isCopyProjectDocumentsPending } = copyProjectDocumentsFromCaseQuery(
    uuid,
    copyProjectDocumentsFormik.resetForm,
  );

  const openNewProjectForm = () => {
    setIdProjectDocument('');
    setReadOnly(false);
  };

  return (
    <>
      {!sidebarItemPair?.readOnly && (
        <>
          <div className={'form-header'}>Podaci o projektima</div>
          <div className={'d-flex justify-content-end pb-4 gap-2'}>
            <div className={'case-copy-from-other-case'}>
              <Input
                placeholder={'Unesite šifru predmeta'}
                maxLength={255}
                addonAppend={
                  isCopyProjectDocumentsPending ? (
                    <FontAwesomeIcon icon="spinner" spin />
                  ) : (
                    <FontAwesomeIcon
                      aria-disabled={
                        (!!copyProjectDocumentsFormik.errors && !!copyProjectDocumentsFormik.errors.caseUuidToCopyFrom) ||
                        copyProjectDocumentsFormik.values.caseUuidToCopyFrom === ''
                      }
                      className={
                        (!!copyProjectDocumentsFormik.errors && !!copyProjectDocumentsFormik.errors.caseUuidToCopyFrom) ||
                        copyProjectDocumentsFormik.values.caseUuidToCopyFrom === ''
                          ? 'disabled'
                          : ''
                      }
                      icon="copy"
                    />
                  )
                }
                value={copyProjectDocumentsFormik.values.caseUuidToCopyFrom}
                onChange={event => {
                  copyProjectDocumentsFormik.setFieldValue('caseUuidToCopyFrom', event.target.value);

                  if (copyProjectDocumentsFormik.submitCount > 0) {
                    copyProjectDocumentsFormik.setErrors({});
                  }
                }}
                addonAppendClick={() => {
                  if (!isCopyProjectDocumentsPending) {
                    copyProjectDocumentsFormik.handleSubmit();
                  }
                }}
                error={
                  copyProjectDocumentsFormik.errors && copyProjectDocumentsFormik.errors.caseUuidToCopyFrom
                    ? copyProjectDocumentsFormik.errors.caseUuidToCopyFrom
                    : ''
                }
              />
            </div>
            <div>
              <Button label={'Dodaj projekt'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openNewProjectForm} />
            </div>
          </div>
        </>
      )}
      <ProjectDocumentsTable
        setProjectDocument={setIdProjectDocument}
        setReadOnly={setReadOnly}
        setProjectDocumentForAttachments={setIdProjectDocumentForAttachments}
        setProjectAttachmentVariant={setProjectAttachmentVariant}
      />
      {idProjectDocument !== null && (
        <>
          {projectDocumentsVariant === CASE_TAB_ENUM.PROJECT_DOCUMENTS && (
            <ProjectDocumentsForm readOnly={readOnly} setProjectDocumentId={setIdProjectDocument} projectDocumentId={idProjectDocument} />
          )}
          {projectDocumentsVariant === CASE_TAB_ENUM.PROJECT_DOCUMENTS_V2 && (
            <ProjectDocumentsFormWithNonMandatoryOib
              readOnly={readOnly}
              setProjectDocumentId={setIdProjectDocument}
              projectDocumentId={idProjectDocument}
            />
          )}
        </>
      )}
      <AttachmentModal
        idProjectDocument={idProjectDocumentForAttachments}
        type={projectAttachmentVariant}
        setIdProjectDocument={setIdProjectDocumentForAttachments}
      />
    </>
  );
};

export default ProjectDocuments;
